export const gapDetails = 
[
    {
      "company": "Agility (Health Squared)",
      "plan": "Gap 200",
      "coPay": "Gap",
      "level": 200,
      "age": "o,<,65",
      "single": "R88",
      "family": "R88",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Gap 200",
      "coPay": "Gap",
      "level": 200,
      "age": "o,>,64",
      "single": "R149",
      "family": "R149",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Gap 500",
      "coPay": "Gap",
      "level": 500,
      "age": "o,<,65",
      "single": "R180",
      "family": "R180",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Gap 500",
      "coPay": "Gap",
      "level": 500,
      "age": "o,>,64",
      "single": "R242",
      "family": "R242",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Combined 200",
      "coPay": "Gap + co",
      "level": 200,
      "age": "o,<,65",
      "single": "R148",
      "family": "R148",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Combined 200",
      "coPay": "Gap + co",
      "level": 200,
      "age": "o,>,64",
      "single": "R207",
      "family": "R207",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Combined 350",
      "coPay": "Gap + co",
      "level": 350,
      "age": "o,<,65",
      "single": "R230",
      "family": "R230",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Combined 350",
      "coPay": "Gap + co",
      "level": 350,
      "age": "o,>,64",
      "single": "R288",
      "family": "R288",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Combined 500",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,65",
      "single": "R303",
      "family": "R303",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Combined 500",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,>,64",
      "single": "R353",
      "family": "R353",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Combined ultra",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,65",
      "single": "R437",
      "family": "R437",
      "logo": "agility.png"
    },
    {
      "company": "Agility (Health Squared)",
      "plan": "Combined ultra",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,>,64",
      "single": "R502",
      "family": "R502",
      "logo": "agility.png"
    },
    {
      "company": "Curemed",
      "plan": "Basic cover 300 (Curemed)",
      "coPay": "Gap",
      "level": 300,
      "age": "p,<,65",
      "single": "R99",
      "family": "R165",
      "logo": "curemed.png"
    },
    {
      "company": "Curemed",
      "plan": "Basic cover 300 (Curemed)",
      "coPay": "Gap",
      "level": 300,
      "age": "p,>,64",
      "single": "R330",
      "family": "R330",
      "logo": "curemed.png"
    },
    {
      "company": "Curemed",
      "plan": "Vital cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,<,65",
      "single": "R220",
      "family": "R220",
      "logo": "curemed.png"
    },
    {
      "company": "Curemed",
      "plan": "Vital cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,>,64",
      "single": "R330",
      "family": "R330",
      "logo": "curemed.png"
    },
    {
      "company": "Curemed",
      "plan": "Super cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,<,65",
      "single": "R250",
      "family": "R250",
      "logo": "curemed.png"
    },
    {
      "company": "Curemed",
      "plan": "Super cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,>,64",
      "single": "R360",
      "family": "R360",
      "logo": "curemed.png"
    },
    {
      "company": "Curemed",
      "plan": "Absolute cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,<,65",
      "single": "R450",
      "family": "R450",
      "logo": "curemed.png"
    },
    {
      "company": "Curemed",
      "plan": "Absolute cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,>,64",
      "single": "R550",
      "family": "R550",
      "logo": "curemed.png"
    },
    {
      "company": "Discovery",
      "plan": "Comprehensive (Exclusive and classic Plans)",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,45",
      "single": "R159",
      "family": "R270",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Comprehensive (Exclusive and classic Plans)",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,65",
      "single": "R270",
      "family": "R410",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Comprehensive (Exclusive and classic Plans)",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,>,64",
      "single": "R345",
      "family": "R570",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Comprehensive (Essencial and coastal plans)",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,45",
      "single": "R300",
      "family": "R685",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Comprehensive (Essencial and coastal plans)",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,65",
      "single": "R549",
      "family": "R1,045",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Comprehensive (Essencial and coastal plans)",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,>,64",
      "single": "R730",
      "family": "R1,375",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Core (Exclusive and classic Plans)",
      "coPay": "Gap + co",
      "level": 250,
      "age": "o,<,45",
      "single": "R100",
      "family": "R175",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Core (Exclusive and classic Plans)",
      "coPay": "Gap + co",
      "level": 250,
      "age": "o,<,65",
      "single": "R180",
      "family": "R215",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Core (Exclusive and classic Plans)",
      "coPay": "Gap + co",
      "level": 250,
      "age": "o,>,64",
      "single": "R210",
      "family": "R315",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Core (Essencial and coastal plans)",
      "coPay": "Gap + co",
      "level": 250,
      "age": "o,<,45",
      "single": "R205",
      "family": "R480",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Core (Essencial and coastal plans)",
      "coPay": "Gap + co",
      "level": 250,
      "age": "o,<,65",
      "single": "R465",
      "family": "R699",
      "logo": "Discovery.png"
    },
    {
      "company": "Discovery",
      "plan": "Core (Essencial and coastal plans)",
      "coPay": "Gap + co",
      "level": 250,
      "age": "o,>,64",
      "single": "R695",
      "family": "R1,115",
      "logo": "Discovery.png"
    },
    {
      "company": "Liberty (Zest)",
      "plan": "Essential",
      "coPay": "Gap",
      "level": 300,
      "age": "p,<,45",
      "single": "R296",
      "family": "R372",
      "logo": "zest.jpg"
    },
    {
      "company": "Liberty (Zest)",
      "plan": "Essential",
      "coPay": "Gap",
      "level": 300,
      "age": "p,<,65",
      "single": "R372",
      "family": "R372",
      "logo": "zest.jpg"
    },
    {
      "company": "Liberty (Zest)",
      "plan": "Essential",
      "coPay": "Gap",
      "level": 300,
      "age": "p,>,64",
      "single": "R424",
      "family": "R424",
      "logo": "zest.jpg"
    },
    {
      "company": "Liberty (Zest)",
      "plan": "Univesal",
      "coPay": "Gap + co",
      "level": 500,
      "age": "p,<,45",
      "single": "R401",
      "family": "R506",
      "logo": "zest.jpg"
    },
    {
      "company": "Liberty (Zest)",
      "plan": "Univesal",
      "coPay": "Gap + co",
      "level": 500,
      "age": "p,<,65",
      "single": "R506",
      "family": "R506",
      "logo": "zest.jpg"
    },
    {
      "company": "Liberty (Zest)",
      "plan": "Univesal",
      "coPay": "Gap + co",
      "level": 500,
      "age": "p,>,64",
      "single": "R568",
      "family": "R568",
      "logo": "zest.jpg"
    },
    {
      "company": "Medgap (Bonitas)",
      "plan": "Primary ",
      "coPay": "Gap + co",
      "level": 300,
      "age": "p,<,31",
      "single": "R185",
      "family": "N/A",
      "logo": "medgap.png"
    },
    {
      "company": "Medgap (Bonitas)",
      "plan": "Primary",
      "coPay": "Gap + co",
      "level": 300,
      "age": "p,<,65",
      "single": "R305",
      "family": "R305",
      "logo": "medgap.png"
    },
    {
      "company": "Medgap (Bonitas)",
      "plan": "Primary",
      "coPay": "Gap + co",
      "level": 300,
      "age": "p,>,64",
      "single": "R529",
      "family": "R529",
      "logo": "medgap.png"
    },
    {
      "company": "Medgap (Bonitas)",
      "plan": "Supreme ",
      "coPay": "Gap + co",
      "level": 300,
      "age": "p,<,31",
      "single": "R230",
      "family": "N/A",
      "logo": "medgap.png"
    },
    {
      "company": "Medgap (Bonitas)",
      "plan": "Supreme",
      "coPay": "Gap + co",
      "level": 300,
      "age": "p,<,65",
      "single": "R382",
      "family": "R382",
      "logo": "medgap.png"
    },
    {
      "company": "Medgap (Bonitas)",
      "plan": "Supreme",
      "coPay": "Gap + co",
      "level": 300,
      "age": "p,>,64",
      "single": "R562",
      "family": "R562",
      "logo": "medgap.png"
    },
    {
      "company": "Momentum",
      "plan": "Momentum Gap cover",
      "coPay": "Gap + co",
      "level": 300,
      "age": "p,<,43",
      "single": "R296",
      "family": "R296",
      "logo": "momentumMed.png"
    },
    {
      "company": "Momentum",
      "plan": "Momentum Gap cover",
      "coPay": "Gap + co",
      "level": 300,
      "age": "p,<,42",
      "single": "R417",
      "family": "R417",
      "logo": "momentumMed.png"
    },
    {
      "company": "Momentum",
      "plan": "Momentum Gap cover",
      "coPay": "Gap + co",
      "level": 300,
      "age": "p,>,64",
      "single": "R537",
      "family": "R537",
      "logo": "momentumMed.png"
    },
    {
      "company": "Sirago",
      "plan": "Ultimate gap cover",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,55",
      "single": "R413",
      "family": "R467",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Ultimate gap cover",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,65",
      "single": "R491",
      "family": "R556",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Ultimate gap cover",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,>,64",
      "single": "R569",
      "family": "R645",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Plus gap cover",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,55",
      "single": "R324",
      "family": "R370",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Plus gap cover",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,65",
      "single": "R400",
      "family": "R457",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Plus gap cover",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,>,64",
      "single": "R475",
      "family": "R543",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Gap assist cover",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,55",
      "single": "R278",
      "family": "R299",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Gap assist cover",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,65",
      "single": "R344",
      "family": "R371",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Gap assist cover",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,>,64",
      "single": "R409",
      "family": "R443",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Gap life cover",
      "coPay": "Gap + co",
      "level": 200,
      "age": "o,<,55",
      "single": "R203",
      "family": "R218",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Gap life cover",
      "coPay": "Gap + co",
      "level": 200,
      "age": "o,<,65",
      "single": "R244",
      "family": "R272",
      "logo": "sirago.png"
    },
    {
      "company": "Sirago",
      "plan": "Gap life cover",
      "coPay": "Gap + co",
      "level": 200,
      "age": "o,>,64",
      "single": "R285",
      "family": "R325",
      "logo": "sirago.png"
    },
    {
      "company": "Stratum",
      "plan": "Elite",
      "coPay": "Gap",
      "level": 500,
      "age": "o,<,65",
      "single": "R342",
      "family": "R420",
      "logo": "stratum.jpg"
    },
    {
      "company": "Stratum",
      "plan": "Elite",
      "coPay": "Gap",
      "level": 500,
      "age": "o,>,64",
      "single": "R555",
      "family": "R679",
      "logo": "stratum.jpg"
    },
    {
      "company": "Stratum",
      "plan": "Co-evolution",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,<,65",
      "single": "R236",
      "family": "R306",
      "logo": "stratum.jpg"
    },
    {
      "company": "Stratum",
      "plan": "Co-evolution",
      "coPay": "Gap + co",
      "level": 500,
      "age": "o,>,64",
      "single": "R473",
      "family": "R473",
      "logo": "stratum.jpg"
    },
    {
      "company": "Stratum",
      "plan": "Base",
      "coPay": "Gap",
      "level": 500,
      "age": "o,<,65",
      "single": "R213",
      "family": "R250",
      "logo": "stratum.jpg"
    },
    {
      "company": "Stratum",
      "plan": "Base",
      "coPay": "Gap",
      "level": 500,
      "age": "o,>,64",
      "single": "R414",
      "family": "R414",
      "logo": "stratum.jpg"
    },
    {
      "company": "Stratum",
      "plan": "Compact 200",
      "coPay": "Gap + co",
      "level": 200,
      "age": "o,<,65",
      "single": "R213",
      "family": "R248",
      "logo": "stratum.jpg"
    },
    {
      "company": "Stratum",
      "plan": "Compact 200",
      "coPay": "Gap + co",
      "level": 200,
      "age": "o,>,64",
      "single": "R414",
      "family": "R414",
      "logo": "stratum.jpg"
    },
    {
      "company": "Stratum",
      "plan": "Access optimiser plus",
      "coPay": "Gap",
      "level": 200,
      "age": "o,<,65",
      "single": "R299",
      "family": "R345",
      "logo": "stratum.jpg"
    },
    {
      "company": "Stratum",
      "plan": "Access optimiser plus",
      "coPay": "Gap",
      "level": 200,
      "age": "o,>,64",
      "single": "R383",
      "family": "R467",
      "logo": "stratum.jpg"
    },
    {
      "company": "TRA (Total risk administrators)",
      "plan": "Basic cover 300",
      "coPay": "Gap",
      "level": 300,
      "age": "p,<,65",
      "single": "R99",
      "family": "R165",
      "logo": "tra.svg"
    },
    {
      "company": "TRA (Total risk administrators)",
      "plan": "Basic cover 300",
      "coPay": "Gap",
      "level": 300,
      "age": "p,>,64",
      "single": "R330",
      "family": "R330",
      "logo": "tra.svg"
    },
    {
      "company": "TRA (Total risk administrators)",
      "plan": "Vital cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,<,65",
      "single": "R220",
      "family": "R220",
      "logo": "tra.svg"
    },
    {
      "company": "TRA (Total risk administrators)",
      "plan": "Vital cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,>,64",
      "single": "R330",
      "family": "R330",
      "logo": "tra.svg"
    },
    {
      "company": "TRA (Total risk administrators)",
      "plan": "Super cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,<,65",
      "single": "R250",
      "family": "R250",
      "logo": "tra.svg"
    },
    {
      "company": "TRA (Total risk administrators)",
      "plan": "Super cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,>,64",
      "single": "R360",
      "family": "R360",
      "logo": "tra.svg"
    },
    {
      "company": "TRA (Total risk administrators)",
      "plan": "Absolute cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,<,65",
      "single": "R450",
      "family": "R450",
      "logo": "tra.svg"
    },
    {
      "company": "TRA (Total risk administrators)",
      "plan": "Absolute cover plus",
      "coPay": "Gap + co",
      "level": 700,
      "age": "p,>,64",
      "single": "R550",
      "family": "R550",
      "logo": "tra.svg"
    },
    {
      "company": "Turnberry",
      "plan": "Premier",
      "coPay": "Gap + co",
      "level": 600,
      "age": "p,<,65",
      "single": "R421",
      "family": "R421",
      "logo": "turnberry.png"
    },
    {
      "company": "Turnberry",
      "plan": "Premier",
      "coPay": "Gap + co",
      "level": 600,
      "age": "p,>,64",
      "single": "R592",
      "family": "R592",
      "logo": "turnberry.png"
    },
    {
      "company": "Turnberry",
      "plan": "Optimal",
      "coPay": "Gap + co",
      "level": 500,
      "age": "p,<,65",
      "single": "R341",
      "family": "R341",
      "logo": "turnberry.png"
    },
    {
      "company": "Turnberry",
      "plan": "Optimal",
      "coPay": "Gap + co",
      "level": 500,
      "age": "p,>,64",
      "single": "R451",
      "family": "R451",
      "logo": "turnberry.png"
    },
    {
      "company": "Turnberry",
      "plan": "Synergy",
      "coPay": "Gap + co",
      "level": 500,
      "age": "p,<,65",
      "single": "R268",
      "family": "R268",
      "logo": "turnberry.png"
    },
    {
      "company": "Turnberry",
      "plan": "Synergy",
      "coPay": "Gap + co",
      "level": 500,
      "age": "p,>,64",
      "single": "R367",
      "family": "R367",
      "logo": "turnberry.png"
    },
    {
      "company": "Turnberry",
      "plan": "Launch",
      "coPay": "Gap",
      "level": 350,
      "age": "p,<,65",
      "single": "R121",
      "family": "R121",
      "logo": "turnberry.png"
    },
    {
      "company": "Turnberry",
      "plan": "Launch",
      "coPay": "Gap",
      "level": 350,
      "age": "p,>,64",
      "single": "R214",
      "family": "R214",
      "logo": "turnberry.png"
    }
   ]


// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/GapDetails.jsx